import { compose, withState } from 'recompose';

export default compose(
  withState('batchUpdateStatus', 'setBatchUpdateStatus', []),
  withState('batchUpdateInProgress', 'setBatchUpdateInProgress', false),
);
